export default __webpack_public_path__ + "static/media/logo-new-dark.b84b0cab.svg";